
    import './styles.scoped.css';
    export default {
  "hide-navigation": "awsui_hide-navigation_2p2ab_1kde4_149",
  "navigation-container": "awsui_navigation-container_2p2ab_1kde4_155",
  "navigation": "awsui_navigation_2p2ab_1kde4_155",
  "is-navigation-open": "awsui_is-navigation-open_2p2ab_1kde4_175",
  "is-navigation-collapsed": "awsui_is-navigation-collapsed_2p2ab_1kde4_179",
  "expand-navigation-toggle": "awsui_expand-navigation-toggle_2p2ab_1kde4_191"
};
  